import { Footer2022, Intro2022 } from '../components';
import { use2022Page } from '../shared';
import { winnerCategories } from '../winnersData';

const Winners2022Zh = () => {
  use2022Page({ cate: 'winners', lang: 'zh', title: '2022智慧生活夥伴大獎 - 得獎名單' });
  return (
    <div className="slpa2022-root">
      <Intro2022 lang="zh" />
      <section id="LeadIn"><div className="wave_bg"><img src="/2022/images/wave_bg.png" alt="" /></div></section>
      <section id="Winners">
        <div className="Winners_info">
          <div className="Winners_Title">得獎名單</div>
          <div className="Winners_TitleLine"><div className="Winners_TitleLineDot"><img src="/2022/images/linedot.png" alt="" /></div></div>
          <div className="Winners_Table">
            {winnerCategories.map((cat) => (
              <div key={cat.key}>
                <div className={cat.className}><p>{cat.titleZh}</p></div>
                {cat.zh.map((item) => (
                  <div className={`${cat.className}_Details`} key={`${cat.key}-${item.award}`}>
                    <div className="Winners_AwardName">{item.award}</div>
                    <div className="Winners_Name">{item.winner}</div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer2022 lang="zh" />
    </div>
  );
};

export default Winners2022Zh;

